import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, withKeys as _withKeys, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "flex flex-column gap-2" };
const _hoisted_2 = { for: "tags" };
const _hoisted_3 = {
    key: 0,
    class: "font-bold"
};
const _hoisted_4 = {
    key: 1,
    class: "font-bold"
};
const _hoisted_5 = { class: "flex align-options-center" };
const _hoisted_6 = {
    key: 0,
    class: "flex flex-row align-items-center justify-content-between m-2 gap-3"
};
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("small", null, "Tag not found ?", -1);
import { computed, onMounted, ref, watch } from "vue";
import { createTag, deleteTag, getIsValidTag, getTagsByCriteria } from "@/repositories/tags.repository";
import AutoComplete from "primevue/autocomplete";
import Button from "primevue/button";
import Chip from "primevue/chip";
import InlineMessage from "primevue/inlinemessage";
export default /*#__PURE__*/ _defineComponent({
    __name: 'OneDeskTagsAutoComplete',
    props: /*#__PURE__*/ _mergeModels({
        label: {},
        rules: {}
    }, {
        "modelValue": {},
        "modelModifiers": {},
    }),
    emits: /*#__PURE__*/ _mergeModels(["update:valid"], ["update:modelValue"]),
    setup(__props, { emit: __emit }) {
        const modelValue = _useModel(__props, "modelValue");
        const errorMessages = ref([]);
        const suggestions = ref([]);
        const loading = ref(false);
        const tagExists = ref(false);
        const props = __props;
        watch(modelValue, async () => {
            await tagIsValid();
        });
        const tagIsValid = async () => {
            tagExists.value = await getIsValidTag(modelValue.value);
            await validate();
        };
        const validate = async () => {
            if (!props.rules)
                errorMessages.value = [];
            errorMessages.value = props.rules?.map((rule) => rule(modelValue.value)).filter((result) => result !== true);
            try {
                if (!tagExists.value && !errorMessages.value.includes("Tag does not exist"))
                    errorMessages.value.push("Tag does not exist");
            }
            catch (e) {
                console.error(e);
            }
        };
        const valid = computed(() => {
            if (modelValue.value?.trim() === "")
                return false;
            emit("update:valid", errorMessages.value.length === 0);
            return errorMessages.value.length === 0;
        });
        const emit = __emit;
        onMounted(() => getTags());
        const selectItem = (event) => {
            modelValue.value = event.value.label;
        };
        const getTags = async (search) => {
            loading.value = true;
            suggestions.value = await getTagsByCriteria(search?.trim());
            loading.value = false;
        };
        const canAddTag = computed(() => {
            return modelValue.value?.trim() !== "" && errorMessages.value.length === 1 && errorMessages.value[0] === "Tag does not exist";
        });
        const addNewTag = async () => {
            const tag = modelValue.value.trim();
            if (!canAddTag.value)
                return;
            await createTag(tag);
            await tagIsValid();
            suggestions.value = [];
        };
        const removeTag = async (id) => {
            await deleteTag(id);
            await getTags();
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("label", _hoisted_2, [
                        (props.label)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(props.label), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_4, "Tags"))
                    ]),
                    _createVNode(_unref(AutoComplete), {
                        "data-testid": "one-desk-tags-auto-complete",
                        modelValue: modelValue.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((modelValue).value = $event)),
                        suggestions: suggestions.value,
                        "linera-label": false,
                        "option-label": "label",
                        "option-value": "label",
                        placeholder: "Enter a tag to select or create",
                        inputId: "tags",
                        onComplete: _cache[1] || (_cache[1] = ($event) => (getTags($event.query))),
                        onKeyup: _withKeys(addNewTag, ["enter"]),
                        invalid: !valid.value,
                        dropdown: "",
                        loading: loading.value,
                        onItemSelect: _cache[2] || (_cache[2] = ($event) => (selectItem($event)))
                    }, {
                        item: _withCtx((slotProps) => [
                            _createVNode(_unref(Chip), {
                                icon: "pi pi-tag",
                                label: slotProps.option.label,
                                removable: "",
                                onRemove: ($event) => (removeTag(slotProps.option.id))
                            }, null, 8, ["label", "onRemove"])
                        ]),
                        option: _withCtx((slotProps) => [
                            _createElementVNode("div", _hoisted_5, [
                                _createVNode(_unref(Chip), {
                                    icon: "pi pi-tag",
                                    label: slotProps.option.label,
                                    removable: "",
                                    onRemove: ($event) => (removeTag(slotProps.option.id))
                                }, null, 8, ["label", "onRemove"])
                            ])
                        ]),
                        footer: _withCtx(() => [
                            (!tagExists.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    _hoisted_7,
                                    _createVNode(_unref(Button), {
                                        size: "small",
                                        icon: "pi pi-plus",
                                        label: "Add Tag",
                                        onClick: addNewTag
                                    })
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        dropdownicon: _withCtx(() => [
                            _createElementVNode("i", {
                                class: _normalizeClass(valid.value ? 'pi pi-check' : 'pi pi-chevron-down')
                            }, null, 2)
                        ]),
                        _: 1
                    }, 8, ["modelValue", "suggestions", "invalid", "loading"])
                ]),
                _createElementVNode("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errorMessages.value, (error, index) => {
                        return (_openBlock(), _createBlock(_unref(InlineMessage), {
                            key: index,
                            severity: "error",
                            class: "my-2"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(error), 1)
                            ]),
                            _: 2
                        }, 1024));
                    }), 128))
                ])
            ], 64));
        };
    }
});
